import { CommonModule, DOCUMENT } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { environment } from '../../../environments/environment'; // Added import
import { SEOService } from '../../services/seo.service';
import { StructuredDataService } from '../../services/structured-data.service';
import { WebContentSchema } from '../../types/structured-data.interfaces'; // Added import

@Component({
  selector: 'app-terms-of-service',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './terms-of-service.component.html',
  styleUrls: ['./terms-of-service.component.scss'],
})
export class TermsOfServiceComponent implements OnInit {
  private document = inject(DOCUMENT);
  private seoService = inject(SEOService);
  private structuredDataService = inject(StructuredDataService);

  ngOnInit() {
    this.setSeoMetadata();
    this.addTermsOfServiceStructuredData(); // Call new method for structured data
  }

  private setSeoMetadata() {
    const canonicalUrl = `${environment.canonicalOrigin}/terms-of-service`;

    this.seoService.updateTags({
      title: 'Terms of Service | Summerry',
      description:
        "Read Summerry's Terms of Service to understand the conditions for using our AI news aggregation platform, including user rights and responsibilities.",
      keywords: 'Terms of Service, Summerry, user agreement, legal terms, service conditions',
      type: 'website',
      url: canonicalUrl,
    });
  }

  // New method to add structured data for the Terms of Service page
  private addTermsOfServiceStructuredData() {
    const origin = environment.canonicalOrigin; // Get origin
    const pageName = 'Terms of Service';
    const pageDescription =
      "Read Summerry's Terms of Service to understand the conditions for using our AI news aggregation platform, including user rights and responsibilities.";
    const breadcrumbItems = [
      { name: 'Home', item: `${origin}/` }, // Use origin
      { name: 'Terms of Service' }, // Current page, no item URL
    ];

    this.structuredDataService.addWebPage({
      name: pageName,
      description: pageDescription,
      breadcrumbItems: breadcrumbItems,
      mainEntity: {
        '@type': 'WebContent',
        name: pageName,
        url: `${origin}/terms-of-service`,
        datePublished: environment.legalDocs.initialPublish,
        dateModified: environment.legalDocs.lastUpdated,
        text: `These Terms of Service govern your access to and use of Summerry. By accessing or using the Service, you agree to be bound by these Terms. If you disagree with any part of the terms, then you may not access the Service. Your access to and use of the Service is also conditioned on your acceptance of and compliance with the Privacy Policy of Summerry. Our Privacy Policy describes Our policies and procedures on the collection, use and disclosure of Your personal information when You use the Application or the Website and tells You about Your privacy rights and how the law protects You. Please read Our Privacy Policy carefully before using Our Service.`, // Abridged for brevity
        author: {
          '@id': `${origin}/#organization`,
        },
        publisher: {
          '@id': `${origin}/#organization`,
        },
      } as WebContentSchema,
    });
  }
}
